// frontend/src/data/degrees.js
export const DEGREES = [
  // Undergraduate — Arts & Science (incl. international variants)
  { code: "BA", label: "Bachelor of Arts (BA)" },
  { code: "HBA", label: "Honours Bachelor of Arts (BA Honours / HBA)" },
  { code: "iBA", label: "International Bachelor of Arts (iBA)" },
  { code: "HiBA", label: "Honours International Bachelor of Arts (iBA Honours)" },

  { code: "BSc", label: "Bachelor of Science (BSc)" },
  { code: "HBSc", label: "Honours Bachelor of Science (BSc Honours / HBSc)" },
  { code: "iBSc", label: "International Bachelor of Science (iBSc)" },
  { code: "HiBSc", label: "Honours International Bachelor of Science (iBSc Honours)" },

  // Engineering & Applied Science
  { code: "BEng", label: "Bachelor of Engineering (BEng)" },
  { code: "HBEng", label: "Honours Bachelor of Engineering (BEng Honours)" },
  { code: "BASc", label: "Bachelor of Applied Science (BASc)" },
  { code: "HBASc", label: "Honours Bachelor of Applied Science (BASc Honours)" },

  // Design & Fine Arts
  { code: "BDes", label: "Bachelor of Design (BDes)" },
  { code: "HBDes", label: "Honours Bachelor of Design (BDes Honours)" },
  { code: "BFA", label: "Bachelor of Fine Arts (BFA)" },
  { code: "HBFA", label: "Honours Bachelor of Fine Arts (BFA Honours)" },

  // Business & Commerce (Schulich + LA&PS)
  { code: "BCom", label: "Bachelor of Commerce (BCom)" },
  { code: "HBCom", label: "Honours Bachelor of Commerce (BCom Honours)" },
  { code: "BBA", label: "Bachelor of Business Administration (BBA)" },
  { code: "HBBA", label: "Honours Bachelor of Business Administration (BBA Honours)" },
  { code: "iBBA", label: "International Bachelor of Business Administration (iBBA)" },
  { code: "HiBBA", label: "Honours International Bachelor of Business Administration (iBBA Honours)" },

  // Environmental & Urban Change
  { code: "BES", label: "Bachelor in Environmental Studies (BES)" },
  { code: "HBES", label: "Honours Bachelor in Environmental Studies (BES Honours)" },

  // Health & Social Work
  { code: "BHS", label: "Bachelor of Health Studies (BHS)" },
  { code: "HBHS", label: "Honours Bachelor of Health Studies (BHS Honours)" },
  { code: "BScN", label: "Bachelor of Science in Nursing (BScN)" },
  { code: "HBScN", label: "Honours Bachelor of Science in Nursing (BScN Honours)" },
  { code: "BSW", label: "Bachelor of Social Work (BSW)" },
  { code: "HBSW", label: "Honours Bachelor of Social Work (BSW Honours)" },

  // Public Administration & HR
  { code: "BPA", label: "Bachelor of Public Administration (BPA)" },
  { code: "HBPA", label: "Honours Bachelor of Public Administration (BPA Honours)" },
  { code: "BHRM", label: "Bachelor of Human Resource Management (BHRM)" },
  { code: "HBHRM", label: "Honours Bachelor of Human Resource Management (BHRM Honours)" },

  // Disaster & Emergency Management
  { code: "BDEM", label: "Bachelor of Disaster & Emergency Management (BDEM)" },
  { code: "HBDEM", label: "Honours Bachelor of Disaster & Emergency Management (BDEM Honours)" },

  // Sport Management
  { code: "BSM", label: "Bachelor in Sport Management (BSM)" },
  { code: "HBSM", label: "Honours Bachelor in Sport Management (BSM Honours)" },

  // Education (no Honours variant)
  { code: "BEd", label: "Bachelor of Education (BEd)" },

  // Professional & Law
  { code: "JD", label: "Juris Doctor (JD)" },

  // Graduate & Professional Masters
  { code: "MA", label: "Master of Arts (MA)" },
  { code: "MSc", label: "Master of Science (MSc)" },
  { code: "MScN", label: "Master of Science in Nursing (MScN)" },
  { code: "MEd", label: "Master of Education (MEd)" },
  { code: "MEng", label: "Master of Engineering (MEng)" },
  { code: "MASc", label: "Master of Applied Science (MASc)" },

  // Schulich master’s (specialized/professional)
  { code: "MBA", label: "Master of Business Administration (MBA)" },
  { code: "EMBA", label: "Executive Master of Business Administration (EMBA)" },
  { code: "MAcc", label: "Master of Accounting (MAcc)" },
  { code: "MBAN", label: "Master of Business Analytics (MBAN)" },
  { code: "MMAI", label: "Master of Management in Artificial Intelligence (MMAI)" },
  { code: "MF", label: "Master of Finance (MF)" },
  { code: "MSCM", label: "Master of Supply Chain Management (MSCM)" },
  { code: "MMgt", label: "Master of Management (MMgt)" },
  { code: "MREI", label: "Master of Real Estate & Infrastructure (MREI)" },
  { code: "MHIA", label: "Master of Health Industry Administration (MHIA)" },

  // LA&PS professional master’s
  { code: "MHRM", label: "Master of Human Resources Management (MHRM)" },
  { code: "MPPAL", label: "Master of Public Policy, Administration & Law (MPPAL)" },
  { code: "MDEM", label: "Master of Disaster & Emergency Management (MDEM)" },
  { code: "MFAc", label: "Master of Financial Accountability (MFAc)" },

  // Arts, Media, Performance & Design + EUC
  { code: "MFA", label: "Master of Fine Arts (MFA)" },
  { code: "MDes", label: "Master of Design (MDes)" },
  { code: "MES", label: "Master in Environmental Studies (MES)" },

  // Law (graduate)
  { code: "LLM", label: "Master of Laws (LLM)" },

  // Doctoral
  { code: "PhD", label: "Doctor of Philosophy (PhD)" }
];
